export default "__VITE_ASSET__13000afd__"